// extracted by mini-css-extract-plugin
module.exports = {"blockInfoIcon":"info-icon_blockInfoIcon__1upbi","icon":"info-icon_icon__257Fe"};